(function () {

  'use strict';


  function initLeadership() {

    var sections = document.querySelectorAll(
      '.leadership-section'
    );

    if (!sections.length) {
      return;
    }


    if (!('IntersectionObserver' in window)) {

      sections.forEach(function (section) {

        section.classList.add('is-visible');

      });

      return;
    }


    var observer = new IntersectionObserver(

      function (entries, observerInstance) {

        entries.forEach(function (entry) {

          if (entry.isIntersecting) {

            entry.target.classList.add(
              'is-visible'
            );

            observerInstance.unobserve(
              entry.target
            );

          }

        });

      },

      {
        threshold: 0.12,
        rootMargin: '0px 0px -40px 0px'
      }

    );


    sections.forEach(function (section) {

      observer.observe(section);

    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initLeadership
    );

  } else {

    initLeadership();

  }


  /* Shopify Theme Editor */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var section =
        event.target.querySelector(
          '.leadership-section'
        );

      if (section) {

        section.classList.add(
          'is-visible'
        );

      }

    }
  );


  document.addEventListener(
    'shopify:block:select',
    function (event) {

      var block = event.target;

      if (
        block &&
        block.classList.contains('investor-card')
      ) {

        block.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

      }

    }
  );


})();